import { AxiosResponse } from 'axios'
import { api } from '../../config'

type Request = {
  socialToken: string
  socialTokenProvider: string
  email: string
  socialUserName: string
  socialUserId: string
  firstName?: string
  lastName?: string
}

type Response = {
  accessToken: string
  refreshToken: string
  expiresIn: number
  refreshExpiresIn: number
}

export const socialLoginService = async (request: Request) => {
  const body = {
    ...request,
    clientId: process.env.REACT_APP_CLIENT_ID
  }
  const { data }: AxiosResponse<Response> = await api.post(
    '/api/v1/auth/users/socialLogin',
    body
  )
  return data
}
